import { useQuery } from '@tanstack/react-query';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { allTenantsQuery } from '../api/platform';
import { AuditTable } from '../components/AuditTable';
import { he } from '../i18n/he';
import { Card, PageHeader, SelectField } from '@avrahami/ui';

/** The whole trail: every tenant's events and the platform's own (sign-ins, staff changes). */
export function AuditPage() {
  const { tenantId = '' } = useSearch({ from: '/app/audit' });
  const navigate = useNavigate({ from: '/audit' });
  const tenants = useQuery(allTenantsQuery);
  return (
    <>
      <PageHeader title={he.audit.title} />
      <Card>
        <div className="mb-4 max-w-sm">
          <SelectField
            label={he.audit.tenant}
            value={tenantId}
            onChange={(event) => {
              const next = event.target.value;
              void navigate({ search: next === '' ? {} : { tenantId: next } });
            }}
          >
            <option value="">{he.audit.allTenants}</option>
            {tenants.data?.items.map((tenant) => (
              <option key={tenant.id} value={tenant.id}>
                {tenant.displayName} ({tenant.slug})
              </option>
            ))}
          </SelectField>
        </div>
        <AuditTable tenantId={tenantId} />
      </Card>
    </>
  );
}
